
<div class="shopReviewThanks">
  <div class="shopReviewThanks__container">
    <div class="shopReviewThanks__header">
      <img :src="imageUrl('/not_found_concierge_logo.png')" alt="コンシェルジュロゴ">
      <h1>口コミの投稿が完了しました</h1>
      <span>口コミをご投稿いただきありがとうございます。</span>
      <span>ご投稿いただいた口コミは、審査後数日以内に反映されます。</span>
      <a href="/">▶トップページへ</a>
    </div>
  </div>
</div>
